export const CITRUS_AD = 'citrusAd';
